import PublicHttpClient from '../../services/public-http-client';
import { Pagination } from '../../../model/pagination';
import { ILiquidationPagedRequest } from '../../../model/sge/liquidation/request/liquidation-paged-request';
import { ILiquidationResponse } from '../../../model/sge/liquidation/response/liquidation-response';

const basePath = (clientId: number, commitmentId: number) => `Public/Client/${clientId}/Commitments/${commitmentId}/Liquidations`;

const list = async (clientId: number, commitmentId: number, params: Omit<ILiquidationPagedRequest, 'commitmentId'>): Promise<Pagination<ILiquidationResponse>> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId, commitmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<ILiquidationResponse>(), response.data));
};

const PublicLiquidationAppService = { list };
export default PublicLiquidationAppService;
